<div class="container">
  <div>
    <ion-item class="header-item">
      <ion-label class="ion-no-margin">Add All Column</ion-label>
      <ion-checkbox slot="start" [(ngModel)]="selectAll" (ionChange)="toggleSelectAll()"></ion-checkbox>
    </ion-item>
  </div>
  <div class="items-list">
    <ion-item *ngFor="let column of columns" lines="none" class="ion-align-items-center">
      <ion-label>{{ column?.colName }}</ion-label>
      <ion-checkbox [(ngModel)]="column.showColumn" (ionChange)="updateSelectAllState()" slot="start" [disabled]="column?.isDisabled || false"></ion-checkbox>
    </ion-item>
  </div>
  <div>
    <ion-item class="footer-item"  (click)="onOk()">
      <ion-text class="ion-text-center">Ok</ion-text>
    </ion-item>
  </div>
</div>